import { useEffect } from "react";

import { SplashContainer, Website } from "./Splash.styles";

import { JagadLogo } from "@components/JagadLogo/JagadLogo";
import BetaLabel from "@components/BetaLabel/BetaLabel";
import { useNavigate } from "react-router";
import { useAuth } from "../../contexts/AuthContext";

const SplashScreen = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      navigate(isAuthenticated ? "/home" : "/onboarding")
    }, 1500)

    return () => clearTimeout(redirectTimer)
  }, [navigate, isAuthenticated])

  return (
    <SplashContainer>
      <JagadLogo type="logo-white-text-white" />
      <Website>
        www.jagad.to
      </Website>
      <BetaLabel />
    </SplashContainer>
  );
};

export default SplashScreen;
